//
//
//
//
//
//
//

import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  props: {
    type: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {},
}
